import { Navigate, Route, Routes } from 'react-router-dom';

import { useCheckoutContext, Article } from '@zooplus/checkout-state';

import { CHECKOUT_STATE_PROJECT_ID, PAGE_ROUTE } from '@utilities/constants';
import { isArrayNotEmpty } from '@utilities/utils';

import Cart from './pages/cart';
import LoginSelection from './pages/login-selection';
import NotFound from './pages/not-found';
import Preview from './pages/preview';

const AppRoutes = () => {
  const { checkoutState, isFetching } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const articles = checkoutState?.cart?.articles;

  const renderPreviewPage = () => {
    return !isFetching && !isArrayNotEmpty(articles as Article[]) ? (
      <Navigate to={PAGE_ROUTE.CART} />
    ) : (
      <Preview />
    );
  };

  return (
    <Routes>
      <Route path="/">
        <Route index element={<Navigate to={PAGE_ROUTE.CART} />} />
        <Route path={PAGE_ROUTE.CART} element={<Cart />} />
        <Route path={PAGE_ROUTE.LOGIN_SELECTION} element={<LoginSelection />} />
        <Route path={PAGE_ROUTE.NEW_PREVIEW} element={renderPreviewPage()} />
        <Route path={PAGE_ROUTE.GUEST_PREVIEW} element={renderPreviewPage()} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
